// image-loader.js
export default function myImageLoader({ src }) {
  return src.split('?')[0];
}
